import {css} from "@emotion/react";

// TODO: remove this and replace usages with some "reset list" style from packages
export const resultsList = css`
    list-style: none;
    padding: 0;
    margin: 0;
`;
